import { useAlgoTileId } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectOrderEntryByIdFromBlotter, selectTradeIdFromAlgoTile } from '@/store/orders/algoOrders/selectors.ts';

const AlgoEditingLiquidityPool = () => {
  const tileId = useAlgoTileId();
  const tradeId = useAppSelector((state) => selectTradeIdFromAlgoTile(state, tileId));

  const orderFromBlotter = useAppSelector((state) =>
    tradeId ? selectOrderEntryByIdFromBlotter(state, tradeId) : undefined,
  );
  const liquidityPool = orderFromBlotter?.liquidityPool;

  return (
    liquidityPool && (
      <OrderRow labelId="order.form.liquidityPool">
        <span className="fs-12">{liquidityPool?.replace(/,/g, ', ')}</span>
      </OrderRow>
    )
  );
};

export default AlgoEditingLiquidityPool;
